// extracted by mini-css-extract-plugin
export default {"PlayerList":"PlayerList_PlayerList__wISlp"};